import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { INotificationPreferenceModel } from '../../model/user/notification-preference.model';
import { NotificationCriteria } from '../../model/user/notification-criteria.model';
import { Notification } from '../../model/user/notification.model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig } from '../../model/environment.model';
import { ENV_CONFIG } from '../../injection-tokens/environment.token';

@Injectable({
    providedIn: 'root',
})
export class UserNotificationService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _preferencePath: string = 'preference';

    public saveNotificationPreference(
        notificationPreference: INotificationPreferenceModel
    ): Observable<INotificationPreferenceModel> {
        return this._httpClient.post<INotificationPreferenceModel>(
            `${this._environment.APP.VC_NOTIFICATION_BASE_URL}/${this._preferencePath}`,
            notificationPreference
        );
    }

    public updateNotificationPreference(
        notificationPreference: INotificationPreferenceModel
    ): Observable<INotificationPreferenceModel> {
        return this._httpClient.put<INotificationPreferenceModel>(
            `${this._environment.APP.VC_NOTIFICATION_BASE_URL}/${this._preferencePath}`,
            notificationPreference
        );
    }

    public getNotificationPreference(
        username: string,
        authenticator: string
    ): Observable<INotificationPreferenceModel> {
        return this._httpClient.get<INotificationPreferenceModel>(
            `${this._environment.APP.VC_NOTIFICATION_BASE_URL}/${this._preferencePath}/${encodeURIComponent(
                username
            )}/${encodeURIComponent(authenticator)}`
        );
    }

    public getNotifications(criteria: NotificationCriteria): Observable<Notification[]> {
        const url = `${this._environment.APP.VC_NOTIFICATION_BASE_URL}/notifications/search`;
        return this._httpClient.post<Notification[]>(url, criteria);
    }
}
